import { AgTechClickEventHandler, AgTechButtonProps, AgTechButton } from "@agtech/web/components/Buttons/AgTechButtons";
import { AgTechFormNumberControl } from "@agtech/web/components/Forms/Controls/AgTechFormNumberControl";
import { AgTechFormTextControl } from "@agtech/web/components/Forms/Controls/AgTechFormTextControl";
import AgTechFormBody from "@agtech/web/components/Forms/Layout/AgTechFormBody";
import { AgTechFormRow } from "@agtech/web/components/Forms/Layout/AgTechFormRow";
import AgTechFormDialog from "@agtech/web/components/Portals/Dialogs/AgTechFormDialog";
import { Payment } from "@sales/data/invoicing/payments/InvoicePaymentData";
import { usePaymentDataEditPaymentAction } from "@sales/data/invoicing/payments/InvoicePaymentDataActions";
import InvoicePaymentTypeSelectionControl from "../../components/forms/InvoicePaymentTypeSelectionControl";
import { AgTechQueryBuilder } from "@agtech/core/data/queries/AgTechDataQueries";
import ContactSelectionControl from "@agtech/web/integrations/contacts/components/selections/ContactSelectionControl";

export type EditPaymentDialogProps = {
    payment: Payment
}

const EditPaymentDialog = (props: EditPaymentDialogProps) => {
    const writePaymentAction = usePaymentDataEditPaymentAction();
    
    return (
        <AgTechFormDialog
            width={600}
            structure={() => ({
                header: 'Edit Payment',
                submitButtonText: 'Save'
            })}
            dialogData={{
                query: AgTechQueryBuilder.buildQueryResult({
                    data: props.payment
                }),
                getDialogData: d => d
            }}
            dialogAction={{
                action: writePaymentAction,
                getActionData: d => d
            }}
         >
            {(formContext) => (
                <AgTechFormBody>
                    <AgTechFormRow>
                        <ContactSelectionControl
                            formEntity={formContext.entity}
                            control={{
                                caption: 'Payer',
                                isRequired: true,
                                width: 65}
                            }
                            contacts={{
                                getSelectedContactId: e => e.payerId,
                                onContactSelected: async (e, v) => {
                                    e.payerId = v?.id ?? 0;
                                    return e;
                                }
                            }}
                        />
                        <AgTechFormNumberControl
                            entityType={formContext.entity}
                            caption="Amount"
                            required={true}
                            value={entity => entity.amount}
                            onControlValueChanged={async (e, val) => {
                                e.amount = val;
                                return e;
                            }}
                            width={35}
                            unit="$"
                        />
                    </AgTechFormRow>
                    <AgTechFormRow>
                        <InvoicePaymentTypeSelectionControl
                            formContext={formContext}
                            getSelectedPaymentType={entity => entity.paymentType.toString()}
                            onPaymentTypeSelected={async (e, v) => {
                                e.paymentType = v?.id ?? 0;
                                return e;
                            }}
                        />
                        <AgTechFormTextControl
                            entityType={formContext.entity}
                            caption="Details"
                            required={false}
                            value={entity => entity.details}
                            onControlValueChanged={async (e, val) => {
                                e.details = val;

                                return e;
                            }}
                        />
                    </AgTechFormRow>
                </AgTechFormBody>
            )}
        </AgTechFormDialog>
    )
}

EditPaymentDialog.Open = (e: AgTechClickEventHandler, props: EditPaymentDialogProps) => e.dialogs.openDialog({
    dialog: () => <EditPaymentDialog {...props} />
});

EditPaymentDialog.Button = (props: AgTechButtonProps & EditPaymentDialogProps) => {
    let buttonProps: AgTechButtonProps = {
        text: 'Edit Payment',
        icon: 'bi bi-credit-card-2-front-fill',
        ...props,
        action: e => EditPaymentDialog.Open(e, props)
    }

    return <AgTechButton {...buttonProps} />
}

export default EditPaymentDialog;